<!-- keydown.enter contido aqui: este componente é embutido dentro do <form> do
     pedido oficial, e Enter num filtro dispararia o submit dele — salvando o
     pedido sem ninguém pedir.

     Padrão visual dos cadastros (shared/styles/_form-cadastro.scss): título de seção com
     ícone, contador e ação à direita. Sem padding lateral próprio — quem embute decide
     (o Pré-Pedido envolve em px-3, como as outras seções dele). -->
<div class="processo-historico" [class.secao-card]="visual === 'cartao'"
     [class.processo-historico--cartao]="visual === 'cartao'"
     (keydown.enter)="$event.preventDefault()">

  <!-- Contador e exportar: iguais nos dois visuais -->
  <ng-template #acoesHistorico>
    <span class="badge bg-light text-dark border" style="font-size: 0.9rem;" *ngIf="totalItems > 0">
      {{ totalItems }} {{ totalItems === 1 ? 'registro' : 'registros' }}
    </span>
    <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="exportar()" [disabled]="isExportando || totalItems === 0">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="isExportando"></span>
      <i class='bx bx-spreadsheet me-1' *ngIf="!isExportando"></i>Exportar Excel
    </button>
  </ng-template>

  <div class="section-header section-header-with-action" *ngIf="visual === 'secao'">
    <div class="section-header-label">
      <i class='bx bx-history'></i>
      <span>Histórico</span>
    </div>
    <div class="section-header-actions">
      <ng-container [ngTemplateOutlet]="acoesHistorico"></ng-container>
    </div>
  </div>

  <div class="secao-card-header" *ngIf="visual === 'cartao'">
    <span class="secao-icone"><i class='bx bx-history'></i></span>
    <div class="secao-titulos">
      <h5 class="secao-titulo">Histórico</h5>
      <p class="secao-subtitulo">Movimentações, alterações e ações do processo</p>
    </div>
    <div class="secao-card-acoes">
      <ng-container [ngTemplateOutlet]="acoesHistorico"></ng-container>
    </div>
  </div>

  <div class="processo-historico-corpo">

    <div class="text-center text-muted py-4" *ngIf="isCarregando">
      <span class="spinner-border spinner-border-sm me-2"></span>carregando...
    </div>

    <div class="text-center text-muted py-4" *ngIf="!isCarregando && eventos.length === 0">
      <i class='bx bx-time-five d-block fs-3 mb-1'></i>
      {{ expandido ? 'Nenhum registro para os filtros aplicados.' : 'Nenhum registro ainda.' }}
    </div>

    <!-- ══ RESUMO — linha do tempo dos últimos movimentos ═════════════════ -->
    <ng-container *ngIf="!expandido && !isCarregando && eventos.length > 0">
      <div class="evento-lista">
        <div class="evento" *ngFor="let e of eventos; let ultimo = last; trackBy: trackByEventoId">

          <div class="evento-trilho">
            <div class="evento-icone" [ngClass]="'evento-icone--' + corAcao(e.acao)">
              <i [class]="iconeAcao(e.acao)"></i>
            </div>
            <div class="evento-conector" *ngIf="!ultimo"></div>
          </div>

          <div class="evento-conteudo">
            <div class="evento-cabecalho">
              <!-- Antes da ação: diz em que fase do processo o evento aconteceu.
                   Num pedido a timeline mistura as duas, e sem isto não dá para
                   saber se "Enviado" foi etapa de pré-pedido ou status de pedido. -->
              <span class="badge-origem" [ngClass]="'badge-origem--' + origemDoEvento(e)">
                {{ rotuloOrigem(e) }}
              </span>

              <span class="badge" [ngClass]="classeAcao(e.acao)">{{ rotuloAcao(e) }}</span>

              <span class="evento-etapa" *ngIf="e.statusNovoNome">
                <i class='bx bx-right-arrow-alt'></i>{{ e.statusNovoNome }}
              </span>

              <span class="evento-usuario">
                <i class='bx bx-user'></i>{{ e.usuarioNome || 'sistema' }}
              </span>

              <!-- `| date`, e NÃO `| dataUtc`: processo_evento.data_evento é gravado
                   com NOW(), e o TimeZone do banco é America/Sao_Paulo — a coluna é
                   hora local. Compensar aqui atrasaria tudo em 3 horas. -->
              <span class="evento-data">{{ e.dataEvento | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>

            <!-- Campo alterado ganha a forma "antes → depois", com a seta em ícone.
                 A `descricao` gravada traz o mesmo conteúdo com "->" em texto, e
                 serve de reserva para evento que não é alteração de campo. -->
            <div class="evento-detalhe" *ngIf="e.campo; else detalheTexto">
              <span class="evento-campo">{{ e.campo }}</span>
              <span class="evento-antes">{{ e.valorAnterior || '—' }}</span>
              <i class='bx bx-right-arrow-alt evento-seta'></i>
              <span class="evento-depois">{{ e.valorNovo || '—' }}</span>
            </div>

            <ng-template #detalheTexto>
              <div class="evento-detalhe evento-detalhe--texto" *ngIf="e.descricao">
                {{ e.descricao }}
              </div>
            </ng-template>
          </div>

        </div>
      </div>
    </ng-container>

    <!-- ══ COMPLETO — tabela com filtros, ordenação e paginação ═══════════ -->
    <ng-container *ngIf="expandido">

      <p class="text-muted small">
        Todas as movimentações, alterações e ações realizadas neste processo.
      </p>

      <div class="row g-2 mb-3">
        <div class="col-lg-2 col-md-4">
          <label class="label-field">De</label>
          <!-- standalone: o componente vive dentro do <form> do pedido oficial, e
               sem isto os filtros entrariam na validade e no estado sujo daquele
               formulário. -->
          <input type="date" class="form-control form-control-sm"
                 [(ngModel)]="filtros.dataInicio" [ngModelOptions]="{standalone: true}"
                 (change)="aplicarFiltros()">
        </div>

        <div class="col-lg-2 col-md-4">
          <label class="label-field">Até</label>
          <input type="date" class="form-control form-control-sm"
                 [(ngModel)]="filtros.dataFim" [ngModelOptions]="{standalone: true}"
                 (change)="aplicarFiltros()">
        </div>

        <div class="col-lg-3 col-md-4">
          <label class="label-field">Ação</label>
          <select class="form-select form-select-sm"
                  [(ngModel)]="filtros.acao" [ngModelOptions]="{standalone: true}"
                  (change)="aplicarFiltros()">
            <option *ngFor="let a of acoes" [value]="a.valor">{{ a.rotulo }}</option>
          </select>
        </div>

        <div class="col-lg-3 col-md-6">
          <label class="label-field">Usuário</label>
          <select class="form-select form-select-sm"
                  [(ngModel)]="filtros.usuarioId" [ngModelOptions]="{standalone: true}"
                  (change)="aplicarFiltros()">
            <option [ngValue]="null">Todos</option>
            <option *ngFor="let u of usuarios" [ngValue]="u.id">{{ u.nome }}</option>
          </select>
        </div>

        <div class="col-lg-3 col-md-6">
          <label class="label-field">Etapa</label>
          <!-- Agrupado por origem, e o valor é a etapa inteira: os ids das duas
               tabelas colidem, então id sozinho não diz de qual lado veio. -->
          <select class="form-select form-select-sm"
                  [(ngModel)]="etapaSelecionada" [ngModelOptions]="{standalone: true}"
                  (change)="onEtapaChange()">
            <option [ngValue]="null">Todas</option>

            <optgroup label="Pré-Pedido" *ngIf="etapasPrePedido.length">
              <option *ngFor="let e of etapasPrePedido" [ngValue]="e">{{ e.nome }}</option>
            </optgroup>

            <optgroup label="Pedido" *ngIf="etapasPedido.length">
              <option *ngFor="let e of etapasPedido" [ngValue]="e">{{ e.nome }}</option>
            </optgroup>
          </select>
        </div>

        <div class="col-lg-2 col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-sm btn-outline-secondary w-100"
                  (click)="limparFiltros()">
            <i class='bx bx-eraser me-1'></i>Limpar
          </button>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!isCarregando && eventos.length > 0">
        <table class="table table-striped table-sm align-middle">
          <thead>
            <tr>
              <th class="cursor-pointer" (click)="ordenarPor('dataEvento')">
                Data/Hora <i [class]="iconeOrdenacao('dataEvento')"></i>
              </th>
              <th class="cursor-pointer" (click)="ordenarPor('usuario')">
                Usuário <i [class]="iconeOrdenacao('usuario')"></i>
              </th>
              <th class="cursor-pointer" (click)="ordenarPor('statusAnterior')">
                De (Etapa anterior) <i [class]="iconeOrdenacao('statusAnterior')"></i>
              </th>
              <th class="cursor-pointer" (click)="ordenarPor('statusNovo')">
                Para (Etapa atual) <i [class]="iconeOrdenacao('statusNovo')"></i>
              </th>
              <th>Fase</th>
              <th class="cursor-pointer" (click)="ordenarPor('acao')">
                Ação <i [class]="iconeOrdenacao('acao')"></i>
              </th>
              <th>Detalhes</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let e of eventos; trackBy: trackByEventoId">
              <td class="text-nowrap">{{ e.dataEvento | date:'dd/MM/yyyy HH:mm:ss' }}</td>

              <td>
                <i class='bx bx-user me-1 text-muted'></i>{{ e.usuarioNome || '—' }}
              </td>

              <td>
                <span class="badge bg-light text-dark" *ngIf="e.statusAnteriorNome">
                  {{ e.statusAnteriorNome }}
                </span>
                <span class="text-muted" *ngIf="!e.statusAnteriorNome">—</span>
              </td>

              <td>
                <span class="badge bg-light text-dark" *ngIf="e.statusNovoNome">
                  {{ e.statusNovoNome }}
                </span>
                <span class="text-muted" *ngIf="!e.statusNovoNome">—</span>
              </td>

              <td class="text-nowrap">
                <span class="badge-origem" [ngClass]="'badge-origem--' + origemDoEvento(e)">
                  {{ rotuloOrigem(e) }}
                </span>
              </td>

              <td class="text-nowrap">
                <span class="badge" [ngClass]="classeAcao(e.acao)">{{ rotuloAcao(e) }}</span>
              </td>

              <td>{{ e.descricao || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- pageSize passado sempre: o paginador recalcula totalPages internamente e
           assume 10 quando não recebe, o que quebraria a navegação. -->
      <app-table-paginator
        *ngIf="totalItems > pageSize"
        [totalItems]="totalItems"
        [pageSize]="pageSize"
        [currentPage]="pageNumber"
        (pageChange)="carregar($event)">
      </app-table-paginator>

    </ng-container>

    <!-- ══ Alternador ════════════════════════════════════════════════════ -->
    <div class="processo-historico-rodape" *ngIf="totalItems > 0 || expandido">
      <button type="button" class="btn-alternar" (click)="alternarExpansao()"
              [disabled]="isCarregando"
              [class.btn-alternar--aberto]="expandido">
        <i class='bx' [class.bx-chevron-down]="!expandido" [class.bx-chevron-up]="expandido"></i>

        <span *ngIf="!expandido">
          Ver todos<ng-container *ngIf="restantes > 0"> — mais {{ restantes }} registro(s)</ng-container>
        </span>
        <span *ngIf="expandido">Recolher</span>
      </button>
    </div>

  </div>
</div>
